import React from "react";

import compose from "../../utils/compose.js";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { fetchReportData, clearStore, openModalDialog } from "../../redux/actions/report-actions.js";
import { Spinner, ErrorIndicator, WrongChannelQtyIndicator, ErrorCmpxLack, ErrorSimple } from "../state-indicators/index.js";

import PopupDialogManager from "../popup-dialog-manager/index.js";
import ReportPage1 from "../report-page1/index.js";
import ReportPage2 from "../report-page2/index.js";
import InfoPanels from "../info-panels/index.js";
import Toolbar from "../toolbar/index.js";

import withLocalization from "../../hoc/with-localization.jsx";

import "./ecg-report-component.scss";
import "../../scss/CardiographReport.scss";

import {
    error_cmpxs_lack,
    error_wrong_channel_qty,
    error_dataapi_url_notset,
    error_session_id_notset,
    error_session_id_closed,
    error_dataapi_request_error,
    error_dataapi_answer_error,
    error_common,
    error_common_markup,
    error_common_user_directory,
    error_common_PDF,
    error_common_wrongIDs,
    error_common_request,
    error_get_data,
    error_get_user_orginfo
} from "../../commonConstants.js";
import { modal_mode_halfscreen } from "../../redux/actions/actionConstants.js";

class Report extends React.Component {
    componentDidMount = () => {
        /** EXTERN PROPERTIES
         * @param {string} res - analysis result ID
         * @param {string} user_sam - optional parameter - sam name of data owner (if open data of another user)
         * @param {string} user_storage_name - optional parameter - storagename of data owner (if open data of another user)
         * @param {string} user_source - id отправителья записи (для определения департамента)
         *
         * @param {string} session_id - идентификатор сессии работы с HotBox
         * @param {string} record -  Название записи для box51
         *
         * @param {string} storageName - Storage name to get user directory
         * @param {string} patientId - Patient ID to get patient info
         *
         * @param {boolean} SACR_config - специальный режим для САКР
         */

        const { lang, fetchData, baseline, _35Hz, _50Hz, spikes, loc } = this.props;

        this.prepareErrorTexts(loc);

        const onResIDChanged = ({ redirectUrl }) => {
            if (redirectUrl) window.location.href = redirectUrl;
        };

        const { dataService, signalService } = this.props;

        dataService.setOnResIDChangedCallback(onResIDChanged);
        dataService.lang = lang;
        signalService.filters = { baseline, _35Hz, _50Hz, spikes };
        fetchData();
    };

    prepareErrorTexts(loc) {
        this.errorTexts = {
            [error_dataapi_url_notset]: loc("errors.dataapi.url_notSet"),
            [error_session_id_notset]: loc("errors.dataapi.session_notSet"),
            [error_session_id_closed]: loc("errors.dataapi.session_closed"),
            [error_dataapi_request_error]: loc("errors.dataapi.request"),
            [error_dataapi_answer_error]: loc("errors.dataapi.answer"),
            [error_common]: loc("errors.commonError"),
            [error_common_markup]: loc("errors.common.markup"),
            [error_common_user_directory]: loc("errors.common.user-directory"),
            [error_common_PDF]: loc("errors.common.PDF"),
            [error_common_wrongIDs]: loc("errors.common.wrongIDs"),
            [error_common_request]: loc("errors.commonError"),
            [error_get_data]: loc("errors.common.getData"),
            [error_get_user_orginfo]: loc("errors.common.orgInfo")
        };
    }

    getSnapshotBeforeUpdate(prevProps) {
        const { baseline: baseline_pre, _35Hz: _35Hz_pre, _50Hz: _50Hz_pre, spikes: spikes_pre } = prevProps;
        const { baseline, _35Hz, _50Hz, spikes } = this.props;
        if (baseline !== baseline_pre || _35Hz !== _35Hz_pre || _50Hz !== _50Hz_pre || spikes !== spikes_pre) {
            this.props.signalService.filters = { baseline, _35Hz, _50Hz, spikes };
        }
        return null;
    }
    componentDidUpdate(prevProps) {
        const { dataService, signalService } = this.props;
        const { user, lang, loc } = this.props;
        const { user: user_pre, lang: lang_pre } = prevProps;

        if (user?.access_token !== user_pre?.access_token) {
            dataService.bearerToken = user?.access_token;
            signalService.bearerToken = user?.access_token;
        }

        if (lang !== lang_pre) {
            if (dataService) {
                dataService.lang = lang;
            }
            this.prepareErrorTexts(loc);
        }
    }

    componentWillUnmount() {
        this.props.clearStore();
    }

    render() {
        const {
            loading,
            error,
            modal: { opened: openedModal },
            halfScreenModalOpened,
            editMode,
            SACR_config,
            loc,
            res,
            anonymousMode,
            Login,
            AppCloseBtn
        } = this.props;
        if (error) {
            console.error(error);
        }

        document.body.classList.toggle("popup_opened", openedModal);
        document.body.classList.toggle("popup_halfscreen", halfScreenModalOpened);

        // Report
        const reportComp = (
            <div className={"preview-area" + (halfScreenModalOpened ? " halfscreen" : "")}>
                <ReportPage1 />
                <ReportPage2 />
            </div>
        );

        // Loading
        <Spinner withCaption />;

        const loadingComp = res ? (
            <div className="preview-area">
                <div className="page" style={{ position: "relative" }}>
                    <Spinner withCaption />
                </div>
                <div className="page" style={{ position: "relative" }}>
                    <Spinner withCaption />
                </div>
            </div>
        ) : (
            <Spinner withCaption />
        );

        // Error component
        let ErrorComp = null;
        if (error?.type === error_wrong_channel_qty) {
            ErrorComp = <WrongChannelQtyIndicator {...{ ...error, loc }} />;
        } else if (error?.type === error_cmpxs_lack) {
            ErrorComp = <ErrorCmpxLack loc={loc} />;
        } else if (error.type !== undefined) {
            ErrorComp = <ErrorSimple loc={loc} text={this.errorTexts[error.type]} id={error?.error_id} />;
        }

        return (
            <div className="ecg-report-component ">
                {editMode ? null : <h2 className="viewReportCaption">{loc("pages.viewReport")}</h2>}
                {!halfScreenModalOpened && (
                    <>
                        {" "}
                        <Toolbar {...{ Login, AppCloseBtn, SACR_config, anonymousMode }} /> <InfoPanels />{" "}
                    </>
                )}
                {editMode ? <PopupDialogManager /> : null}
                {error ? <ErrorIndicator withCaption descriptionComponent={ErrorComp} /> : loading ? loadingComp : reportComp}
            </div>
        );
    }
}

const mapStateToProps = ({
    oidc: { user },
    reportApp: {
        app: {
            loadState: { loading, error },
            modal,
            settings: { editMode, lang }
        },
        reportData
    }
}) => {
    const { baseline, _35Hz, _50Hz, spikes } = reportData?.settings.graphs.signalFilters ?? {};
    return {
        loading,
        error,
        modal,
        halfScreenModalOpened: modal.opened && modal.dialogMode === modal_mode_halfscreen,
        editMode,
        lang,
        user,
        baseline,
        resultID: reportData?.resultID,
        _35Hz,
        _50Hz,
        spikes,
        stimulator: reportData?.report?.stimulator
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    const { getReportData, check, onResIDChangedCallback } = ownProps.dataService;
    return bindActionCreators(
        {
            fetchData: fetchReportData(getReportData, check, onResIDChangedCallback),
            clearStore,
            openModalDialog
        },
        dispatch
    );
};

export default compose(withLocalization, connect(mapStateToProps, mapDispatchToProps))(Report);
